import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Popup } from "semantic-ui-react";
import ScheduledThreeDotPopup from "../../Published/ongoing_threeDot_ppup/ScheduledThreeDotPopup";
import Delete from "../../confirmation_Screen/Delete";
import moment from "moment";
import { timeHelper } from "../../../../../Utils/datetime_helper";
import { BookText, CalendarDays } from "lucide-react";
// Here all css comes in published_hw.css
const ScheduleAssessBox = ({ assessment, setDeactiveProcess }) => {
  const [delete1, setDelete1] = useState(false);
  const {
    id,
    name,
    section_id,
    standard_id,
    subject_id,
    deadline,
    schedule_date,
    schedule_time,
  } = assessment;
  const cardStyle = {
    height: "97px",
    position: "relative",
  };

  // const timeHelper = (date, time) => {
  //   // Parse date string

  //   console.log("date today date", date)
  //   const dateTime = new Date(date);

  //   // Extract hours and minutes from the time string
  //   const [hours, minutes] = time.split(":").map(Number);

  //   // Set hours and minutes in the local time zone
  //   dateTime.setUTCHours(hours);
  //   dateTime.setUTCMinutes(minutes);

  //   // Determine if it's AM or PM
  //   const am_pm = dateTime.getHours() >= 12 ? "pm" : "am";

  //   // Format the output date string
  //   const formattedDate = `${dateTime.getDate().toString().padStart(2, "0")}/${(
  //     dateTime.getMonth() + 1
  //   )
  //     .toString()
  //     .padStart(2, "0")}/${dateTime.getFullYear()} - ${dateTime
  //       .getHours()
  //       .toString()
  //       .padStart(2, "0")}:${dateTime
  //         .getMinutes()
  //         .toString()
  //         .padStart(2, "0")} ${am_pm}`;
  //   console.log("formattedDate", formattedDate)

  //   return formattedDate;
  // };

  const dateHelper = (a) => {
    const dateObj = new Date(a);
    const outputDateString = moment(a).format("DD/MM/YYYY");
    return outputDateString;
  };
  // const timeHelper = (time) => {

  //   const [hours, minutes] = time.split(":").map(Number);

  //   let dateObj = new Date();
  //   dateObj.setUTCHours(hours + 5);
  //   dateObj.setUTCMinutes(minutes + 30);

  //   // Format the UTC time correctly

  //   const am_pm = dateObj.getHours() >= 12 ? "pm" : "am";
  //   const utcHours = dateObj.getUTCHours().toString().padStart(2, "0");
  //   const utcMinutes = dateObj.getUTCMinutes().toString().padStart(2, "0");

  //   const outputDateString = `${utcHours}:${utcMinutes} ${am_pm.toUpperCase()}`;

  //   console.log("Converted UTC Time:", outputDateString);
  //   return outputDateString;
  // };

  const reduceSubjectName = (text, length) => {
    if (text.length < length) {
      return text;
    }
    return text.slice(0, length) + "...";
  };

  const subjectColor =
    "#" + (assessment?.subject_id?.subject_color || "000000");

  return (
    <>
      <div
        className="w-100 h-100 d-flex flex-column py-2 px-3 text-start shadow-sm rounded-4 "
        style={{
          backgroundColor: "#FDEFE3",
          borderTop: `4px solid ${subjectColor}`,
          borderRight: "4px solid #8D4B28",
          borderBottom: "1px solid #8D4B28",
          borderLeft: "1px solid #8D4B28",
          borderRadius: "0.75rem",
          ...cardStyle,
        }}
      >
        <div className="d-flex justify-content-between align-items-start mb-2">
          <NavLink
            to={`/ScheduleQList`}
            state={{ assessmentId: id, assessment }}
            className="text-dark fw-semibold text-decoration-none"
          >
            {`${standard_id?.name} - ${section_id?.name} | `}{" "}
            <span title={subject_id?.name} className="poppins-semibold">
              {reduceSubjectName(subject_id?.name, 25)}
            </span>
          </NavLink>
          {assessment.isAdaptive && (
            <span
              style={{
                padding: "7px 12px",
                position: "absolute",
                top: "18px",
                right: "0%",
                borderRadius: "6px",
              }}
            >
              <img
                src="/images/adaptiveImg.png"
                alt="img"
                style={{ width: "70px" }}
              />
            </span>
          )}
          {assessment.autoEvalEnabled && (
            <span
              style={{
                padding: "0px 10px",
                position: "absolute",
                top: "20px",
                right: "0%",
                borderRadius: "6px",
              }}
            >
              <img
                src="/images/auto-eva.png"
                alt="img"
                style={{ width: "45px" }}
              />
            </span>
          )}
          <Popup
            trigger={
              <img
                src="/images/menu-dots-vertical 1.svg"
                className="hw_card_three_dot"
                alt=""
              />
            }
            content={
              <div className="hw_popup_box_size">
                <ScheduledThreeDotPopup
                  setDeactiveProcess={setDeactiveProcess}
                  assessmentId={id}
                  setDelete={setDelete1}
                  isAdaptive={assessment?.isAdaptive}
                  autoEvaluate={assessment?.autoEvalEnabled}
                />
              </div>
            }
            on="click"
            hideOnScroll
            position="bottom right"
          />
        </div>
        <NavLink
          to="/ScheduleQList"
          state={{ assessmentId: id, assessment: assessment }}
          className="text-dark fw-semibold text-decoration-none"
        >
          <div className="d-flex align-items-center mb-1">
            <BookText size={16} className="me-2 text-dark" />
            <div className=" text-truncate poppins-semibold" title={name}>
              {reduceSubjectName(name, 30)}
            </div>
          </div>
          <div className="d-flex align-items-center">
            <CalendarDays size={16} className="me-2 text-dark" />
            <div className="d-flex flex-column">
              <small className="me-1">Scheduled On </small>
              <small className=" text-dark">
                {dateHelper(schedule_date)} {" - "}
                {timeHelper(schedule_time)}
              </small>
            </div>
          </div>
        </NavLink>
      </div>
      {delete1 && (
        <Delete
          setDeactiveProcess={setDeactiveProcess}
          assessmentId={id}
          setDelete={setDelete1}
        />
      )}
    </>
  );
};

export default ScheduleAssessBox;
